module.exports = __webpack_public_path__ + "5a59b48a6258d218054404dcd1b4ec15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/google_2022_chart.png
// module id = 1682
// module chunks = 0